







































import Vue from "vue";

export default Vue.extend({

    data() {
        return {
            formVisible: false,
            usernameInput: '',
            passwordInput: '',
        };
    },

    computed: {
        user() {
            return this.$store.state.user;
        }
    },

    mounted() {
        /*
        // Check if we're already logged in
        if (!this.$store.state.user)
            this.logIn();
        */
    },

    methods: {
        onSubmit() {
            this.logIn(this.usernameInput, this.passwordInput);
            this.usernameInput = '';
            this.passwordInput = '';
        },

        logIn(username?: string, pass?: string) {
            this.$store.dispatch('logIn', {
                username,
                pass,
            });
        },

        logOut() {
            this.formVisible = false;
            this.$store.dispatch('logOut');
        }
    }
});
